import { MONITOR_VALUE } from '@/common/constant'

enum MONITOR_SIGN {
  INIT_SUCCESS_RATE = 'FrontPaymentInitSuccessRate', // 前置收银台成功率
  INIT_DURATION = 'FrontPaymentInitDuration', // 前置收银台加载时长
  CHANGE_PAY_WAY = 'FrontPaymentChangePayWaySuccessRate', // 前置收银台切换支付方式成功率
  PAY_SUCCESS_RATE = 'FrontPaymentPaySuccessRate', // 前置收银台支付成功率
}

enum MONITOR_CODE {
  INIT_SUCCESS = '100000', // 初始化成功
  INIT_FAILED = '100001', // 初始化失败
  INIT_TIMEOUT = '100002', // 初始化超时
  UNKNOW = '100003', // 未知错误
}

export { MONITOR_SIGN, MONITOR_VALUE, MONITOR_CODE }
